import { render, staticRenderFns } from "./daHuoDetailV4.vue?vue&type=template&id=a9e659a4&scoped=true&"
import script from "./daHuoDetailV4.vue?vue&type=script&lang=js&"
export * from "./daHuoDetailV4.vue?vue&type=script&lang=js&"
import style0 from "./daHuoDetailV4.vue?vue&type=style&index=0&id=a9e659a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e659a4",
  null
  
)

export default component.exports